import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
// import { SuperAdminTopTextSearchIcon } from "../../superAdminReusable/reusableTable/SuperAdminTopTextSearchIcon";
// import Filter from "../../../reusableComponents/allPopupReusable/tableNumberPopup/Filter";
import { AllVendorTableHead } from "./superAdminVendorTable/firstPageTable/AllVendorTableHead";
import { AllVendorTableBody } from "./superAdminVendorTable/firstPageTable/AllVendorTableBody";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_all_admin_pending_vendors,
  get_vendor_single_rating_review,
} from "../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";
import isEmpty from "../../../../store/validation/is-Empty";
// import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import { FilterAllVendorsPending } from "./FilterAllVendorsPending";
import { getSubCateogryWithCategoryId } from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import moment from "moment";
import { SmallLoader } from "../../../Loader/SmallLoader";
import { SortComponent } from "../../../reusableComponents/SortAndFilterComponent/SortComponent";
import BasicPagination from "../../../Pagination/Pagination";
import CSVDownloader from "../../../reusableComponents/csvDownload/csvDownload";
import NoContent from "../../../reusableComponents/NoContentComponent";

export class SuperAdminPendingVendorsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentState: true,
      displayFilter: false,
      adminAllPendingDiners: [],
      pendingCount: 0,
      downloadData: [],
      // onHoldCount: 0,
      search: "",
      chat: false,
      locationSearch: "",
      startDate: "",
      endDate: "",
      startDateSearch: "",
      endDateSearch: "",
      sortBy: "name",
      location: "",
      softOnboardedSearch: false,
      softOnboarded: false,
      categoryList: [],
      loading: false,
      resType: "",
      resTypeSearch: "",
      activeStatusRecord: false,
      anchorEl: null,
      restaurantReverse: "",
      pageNo: 1,
      start: 0,
      end: 50,
      filtereddata_length: 0,
    };
    // this.chatRef = React.createRef();
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };
  handleSelect = (value) => (e) => {
    this.setState({
      restaurantReverse: value,
      restaurant_type: "",
    });
    this.handleClose();
  };

  HandleChat = (e) => {
    this.setState({ chat: !this.state.chat });
  };
  // openChatWindow = () => {
  //   this.chatRef.current.openNav();
  // };

  componentDidMount() {
    if (this.props.get_all_admin_pending_vendors) {
      this.props.get_all_admin_pending_vendors(
        this.props.auth.user.accessToken,
        true,
        moment().subtract(30, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD")
      );
    }
    this.props.getSubCateogryWithCategoryId(
      this.onSuccessGetSubCategory,
      "5f562c9094ac7fdf47ea1d0a"
    );
  }

  onSuccessGetSubCategory = (data) => {
    var subC = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].status === "APPROVED") subC.push(data[i].title);
    }
    this.setState({ categoryList: subC });
    // setLoading(false);
    return subC;
  };

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.admin_pending_vendors.data !== nextState.hasSetPending)
    ) {
      return {
        adminAllPendingDiners: nextProps.admin_pending_vendors.data,
        hasSetPending: true,
      };
    }
    return null;
  }

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  toggleFunction = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  handleShowFilter = (e) => {
    this.setState({
      displayFilter: !this.state.displayFilter,
      startDate: "",
      endDate: "",
      startDateSearch: "",
      endDateSearch: "",
      locationSearch: "",
      location: "",
      softOnboardedSearch: false,
      softOnboarded: false,
      resType: "",
      resTypeSearch: "",
    });
  };

  ratingReviewAction = (data) => (e) => {
    this.props.get_vendor_single_rating_review(data, this.props.history);
  };

  handleProfileClick = (data) => (e) => {
    this.props.history.push({
      pathname: "/pendingvendorsprofileview",
      state: { data: data },
    });
  };

  onSearchChange = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  handleChange = () => {
    this.setState({
      softOnboarded: !this.state.softOnboarded,
    });
  };

  onClickSearchButton = () => {
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    this.setState({ startDateSearch: startDate, endDateSearch: endDate });
    this.setState({ locationSearch: this.state.location });
    this.setState({ softOnboardedSearch: this.state.softOnboarded });
    this.setState({ resTypeSearch: this.state.resType });
    this.setState({ displayFilter: !this.state.displayFilter });
  };

  sortByChangeCode = (event) => {
    const sortByValue = event.target.value;
    this.setState({ sortBy: sortByValue });
    let startDate = "";
    let endDate = new Date();
    if (sortByValue === "name") {
      this.setState({ startDateSearch: "", endDateSearch: "" });
    } else if (sortByValue === "Today") {
      startDate = new Date();
      this.setState({
        startDateSearch: moment(startDate).format("YYYY-MM-DD"),
        endDateSearch: moment(endDate).format("YYYY-MM-DD"),
      });
    }
  };

  renderAllVendorsBody = () => {
    const { adminAllPendingDiners, activeStatusRecord } = this.state;
    let filtereddata = [];
    if (activeStatusRecord === false) {
      filtereddata =
        adminAllPendingDiners &&
        adminAllPendingDiners.filter((pendingVendor) => pendingVendor);
    } else {
      filtereddata =
        adminAllPendingDiners &&
        adminAllPendingDiners.filter(
          (pendingVendor) => pendingVendor.vendor.onHold === true
        );
    }
    if (this.state.softOnboardedSearch === true) {
      filtereddata =
        adminAllPendingDiners &&
        adminAllPendingDiners.filter(
          (pendingVendor) => pendingVendor?.softOnboarding === true
        );
    } else {
      filtereddata =
        adminAllPendingDiners &&
        adminAllPendingDiners.filter((pendingVendor) => pendingVendor);
    }
    if (this.state.restaurantReverse === "A-Z") {
      filtereddata =
        adminAllPendingDiners &&
        adminAllPendingDiners.sort((a, b) => {
          if (a.restaurant_name < b.restaurant_name) return -1;
          if (a.restaurant_name > b.restaurant_name) return 1;
          return 0;
        });
    } else if (this.state.restaurantReverse === "Z-A") {
      filtereddata =
        adminAllPendingDiners &&
        adminAllPendingDiners.sort((a, b) => {
          if (a.restaurant_name < b.restaurant_name) return 1;
          if (a.restaurant_name > b.restaurant_name) return -1;
          return 0;
        });
    }

    filtereddata =
      filtereddata &&
      filtereddata.map((vendor) => {
        vendor.point_of_contact.map((contact) => {
          if (contact.defaultChecked === true) {
            vendor.primary_detail = contact;
            if (contact && contact.enquiry_emails) {
              vendor.primary_email = contact.enquiry_emails[0];
            }
            if (contact.phone_numbers && contact.phone_numbers) {
              vendor.primary_contact = contact.phone_numbers[0].mobile_no;
            }
          }
        });
        return vendor;
      });

    filtereddata =
      filtereddata &&
      filtereddata.filter((item) => {
        return (
          (((item && item._id && item._id.includes(this.state.search)) ||
            (item &&
              item.restaurant_name &&
              item.restaurant_name
                .toLowerCase()
                .includes(this.state.search.toLowerCase())) ||
            (item &&
              item.primary_restaurant_type[0] &&
              item.primary_restaurant_type[0].title &&
              item.primary_restaurant_type[0].title
                .toLowerCase()
                .includes(this.state.search.toLocaleLowerCase())) ||
            (item &&
              item.primary_email &&
              item.primary_email.toLowerCase().includes(this.state.search)) ||
            (item &&
              item.primary_contact &&
              item.primary_contact
                .toLowerCase()
                .includes(this.state.search))) &&
            ((item && this.state.locationSearch === "" && item) ||
              (item &&
                this.state.locationSearch !== "" &&
                item.city &&
                item.city
                  .toLowerCase()
                  .includes(this.state.locationSearch.toLowerCase()))) &&
            ((item &&
              this.state.startDateSearch === "" &&
              this.state.endDateSearch === "" &&
              item) ||
              (item &&
                item.createdAt &&
                this.state.startDateSearch !== "" &&
                this.state.endDateSearch !== "" &&
                this.state.startDateSearch <=
                  moment(item.createdAt).format("YYYY-MM-DD") &&
                moment(item.createdAt).format("YYYY-MM-DD") <=
                  this.state.endDateSearch)) &&
            ((item && this.state.resTypeSearch === "" && item) ||
              (item &&
                item.primary_restaurant_type[0] &&
                item.primary_restaurant_type[0].title &&
                item.primary_restaurant_type[0].title
                  .toLowerCase()
                  .includes(this.state.resTypeSearch.toLocaleLowerCase())))) ||
          item?.vendor?.referral_code
            ?.toLowerCase()
            ?.includes(this.state.search?.toLowerCase())
        );
      });
    if (!isEmpty(filtereddata)) {
      return (
        filtereddata &&
        filtereddata
          .slice(this.state.start, this.state.end)
          .map((data, index) => (
            <React.Fragment key={index}>
              <AllVendorTableBody
                setDataForPagination={(data) => {
                  this.setState({ filtereddata_length: data });
                }}
                index={index}
                wholeData={filtereddata.length}
                vendorData={data}
                sendData={filtereddata}
                setDataWhole={(e) => this.setState({ downloadData: e })}
                email={data.enquiry_email[0]}
                primaryPhone={
                  data.contact_detail[0].country_code +
                  " " +
                  data.contact_detail[0].mobile_no
                }
                ratingReviewAction={this.ratingReviewAction(data)}
                handleProfileClick={this.handleProfileClick(data)}
                openChatWindow={this.openChatWindow}
              />
            </React.Fragment>
          ))
      );
    }
  };

  onClickActiveStatusRecords = () => {
    this.setState({
      activeStatusRecord: !this.state.activeStatusRecord,
      anchorEl: null,
      restaurantReverse: "",
    });
  };

  handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 50 - 50;
    this.setState({ start: calcStart, end: pageNo * 50, pageNo: pageNo });
  };

  render() {
    // let pendingRequestCount = "";
    // pendingRequestCount =
    //   this.state.adminAllPendingDiners &&
    //   this.state.adminAllPendingDiners.filter((pendingVendor) => pendingVendor);

    // let onHoldRequestCount = "";
    // onHoldRequestCount =
    //   this.state.adminAllPendingDiners &&
    //   this.state.adminAllPendingDiners.filter(
    //     (pendingVendor) => pendingVendor.vendor.onHold === true
    //   );
    // download data
    const downloadData = {
      headers: [
        { label: "BusinessId", key: "bid" },
        { label: "Business Name", key: "bname" },
        { label: "Primary Contact", key: "contact" },
        { label: "Address", key: "address" },
        { label: "Restaurant Type", key: "restype" },
      ],
      data: this.state.downloadData
        ? this.state.downloadData?.map((ele) => {
            // console.log(ele?.restaurant_name, "******ele***");
            return {
              bid: ele?._id.substr(ele?._id.length - 15),
              bname: ele?.restaurant_name,
              contact: `${
                ele?.primary_detail?.firstName ||
                " " + ele?.primary_detail?.lastName ||
                ""
              } \n ${ele?.primary_detail?.enquiry_emails[0] || ""} \n ${
                ele?.primary_detail?.phone_numbers[0]?.country_code +
                " " +
                ele?.primary_detail?.phone_numbers[0]?.mobile_no
              }`,
              address: `${ele?.restaurant_address || ""}`,
              restype:
                ele?.primary_restaurant_type.length !== 0
                  ? ele?.primary_restaurant_type[0].title
                  : "" || "",
            };
          })
        : [],
    };
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              {/* <ChatWindow ref={this.chatRef} /> */}
              <HomeReusableTopBarNavigation displayText="Pending Vendors" />
              <div className="super-admin-inside-right-side-panel">
                <div className="seating_dashboard_top_new_header">
                  <div className="row">
                    <div className="col-6">
                      <h4>Pending Vendors</h4>
                    </div>
                    <div className="col-6 text-right">
                      <button
                        onClick={(e) => this.props.history.push("/addvendor")}
                        className="btn add_button_custom_1"
                      >
                        + Add Vendor
                      </button>
                    </div>
                  </div>
                </div>
                <FilterAllVendorsPending
                  handleShowFilter={this.handleShowFilter}
                  showFilter={this.state.displayFilter}
                  sortBy={this.state.sortBy}
                  onChange={(e) => this.setState({ search: e.target.value })}
                  search={this.state.search}
                  sortByChangeCode={this.sortByChangeCode}
                  handleSaveButton={() => this.onClickSearchButton()}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  onStartDateChange={(e) =>
                    this.setState({ startDate: e.target.value })
                  }
                  onEndDateChange={(e) =>
                    this.setState({ endDate: e.target.value })
                  }
                  location={this.state.location}
                  onChangeLocation={(e) =>
                    this.setState({ location: e.target.value })
                  }
                  categoryList={this.state.categoryList}
                  resType={this.state.resType}
                  resTypeChangeHandler={(e) =>
                    this.setState({ resType: e.target.value })
                  }
                  activeButtonState={this.state.activeStatusRecord}
                  onAllHoldClick={() => this.onClickActiveStatusRecords()}
                  pendingCount={
                    this.props?.admin_pending_vendors?.stats?.pendingCount
                  }
                  onHoldCount={
                    this.props?.admin_pending_vendors?.stats?.holdCount
                  }
                  softOnboarded={this.state.softOnboarded}
                  onChangeSoftOnboarded={this.handleChange}
                  sortMenuButton={
                    <SortComponent
                      handleClick={this.handleClick}
                      anchorEl={this.state.anchorEl}
                      handleClose={this.handleClose}
                      selectClick={(data) => this.handleSelect(data)}
                      sortImgWidth={true}
                    />
                  }
                  downloadButton={
                    <CSVDownloader
                      filename="Pending vendors Reports"
                      headers={downloadData.headers}
                      data={downloadData.data}
                      sortImgWidth={true}
                    />
                  }
                />
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table>
                    <thead>
                      <AllVendorTableHead />
                    </thead>
                    {this.state.adminAllPendingDiners?.length ? (
                      this.props.auth.secondary_loader ||
                      this.props.auth.loader ? (
                        <SmallLoader />
                      ) : (
                        this.renderAllVendorsBody()
                      )
                    ) : (
                      <NoContent />
                    )}
                  </Table>
                </div>
                <BasicPagination
                  totalRecords={this.state.filtereddata_length}
                  limit={50}
                  batch={this.state.pageNo}
                  onBatchChange={(e) => this.handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
// }

SuperAdminPendingVendorsComponent.propTypes = {
  admin_pending_vendors: PropTypes.array.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  getSubCateogryWithCategoryId: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  admin_pending_vendors: state.adminAllVendorsInfo.superAdminAllPendingVendors,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_admin_pending_vendors,
  get_vendor_single_rating_review,
  getSubCateogryWithCategoryId,
})(withRouter(SuperAdminPendingVendorsComponent));
